import React, { useEffect, useState } from "react";
import {Badge} from 'react-bootstrap'
import Button from "../../../Components/commonButton/commonButton";
import TextField from "../../../Components/textField/textField";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import Editable from "../../../Components/editable/editable";
import Select from "../../../Components/select/select";
import Validation from "../../../Components/validation/validation";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import TableEditable from "../../../Components/tableEditable/TableEditable";
import "./popUp.css";
import "../general.css";


const AddItems = () => {
  const [show, setShow] = useState(false)
  const [description, setDescription] = useState("")
  const [code, setCode] = useState("")
  const [id, setId] = useState(0)
  const [message, setMessage] = useState("")
  const [machines, setMachines] = useState([])
  const [reload, setReload] = useState(false)
  const [render, setRender] = useState(false)
  const [operations, setOperations] = useState([])
  const [objEdit, setObjEdit] = useState(
  { code: "", alternative: "", pph: "", piece_cicle: "",time_wait_piece_cicle:"",machine: 0})
  const [codeOp, setCodeOp] = useState("");
  const [alternative, setAlternative] = useState("");
  const [pph, setPph] = useState("");
  const [piece_cicle, setPieceCicle] = useState("");
  const [timeWaitPieceCicle, setTimeWaitPieceCicle] = useState("");
  const [objEditPortuguese, setObjEditPortuguese] = useState(
  {["Código"]: "", Alternativa: "", PPH: "", ['Nº Peça/Ciclo']: "",["Tempo de espera"]:"",Máquina: 0})
  const [selected_MachineOp, SetSelectedMachine] = useState("")
  const [operationsAllprops, SetOpAllProps] = useState([])
  const [id_machine, setIdMachine] = useState(0)
  let [count, setCount] = useState(0)
  const [units, setUnits] = useState([{value: "pcs", label: "Peça"},{value: "m", label: "Metro Linear"},{value: "m2", label: "Metro Quadrado"}, {value: "g", label: "Gramas"}]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [popUpShow,setPopUpShow] = useState(false);
  const [length, setlength] = useState(null);
  const [width, setWidth] = useState(null);
  const [notification, setNotification] = useState(false);
  const [notification_type, setNotificationType] = useState("success");
  const [notification_message, setNotificationMessage] = useState("");


  useEffect(() => {
    let arr = []
    Api.get('/machines').then((response) => {
      response.data.forEach(element => {
        arr.push({ value: element.id, label: element.description + element.code })
      })
      setMachines([...arr])

    }).catch(err => {

    })
  }, [])

  const sendData = () => {
    if (description !== "" && code !== "" && operations.length > 0) {
      Api.post("/items/", [{
        code: code,
        description: description,
        operations: operations,
        unit: selectedUnit.value,
        width: width,
        lengthOP: length
      }])
        .then((res) => {
          setNotification(true);
          setNotificationType("success");
          setNotificationMessage("Item cadastrado com sucesso!");
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        })
        .catch((err) => {
          if (err.response.status === 400) {
            setMessage(err.response.data.response)
            setShow(true)
          }
        });
    } else {
      setMessage("Necessário preencher todos os campos.")
      setShow(true)
    }
  };

  const callbackfunction = () => { setShow(false) };

  const setOperation = (value, name) => {
    let validation = '';
    let portuguese_name = '';
    switch (name) {
      case 'code':  
        validation = Validation("varchar", value);
        portuguese_name = 'Código'
        break;
      case 'alternative':
        validation = Validation("int", value);
        portuguese_name = 'Alternativa'
        break;
      case 'pph':
        validation = Validation("int", value);
        portuguese_name = 'PPH'
        break;
      case 'piece_cicle':
        validation = value;
        portuguese_name = ['Nº Peça/Ciclo']
        break;
      case 'time_wait_piece_cicle':
        validation = Validation("int", value);
        portuguese_name = ['Tempo de espera']
        break;
      case 'machine':
        validation = value;
        portuguese_name = 'Máquina'
        break;
    }

    objEditPortuguese[portuguese_name] = validation;
    objEdit[name] = validation;
    objEdit["id"] = count;
  }

  const delOperationNew = (code, alternative)=>{
    let operations1 = operations.filter((e)=> e.code != code && e.alternative != alternative);
    console.log(operations1)
    setOperations(operations1);
  }

  const altOperation = (codeOperation, alternativeOperation, pph, piece_cicle, time_wait_piece_cicle)=>{

    let operation = operations.findIndex((e)=>e.code == codeOperation && e.alternative == alternativeOperation);


    let operations1 = operations;
    operations1[operation].pph = pph.toString().slice(-1) == "." ? parseFloat(pph.toString().slice(0,-1)) : pph;
    operations1[operation].piece_cicle = piece_cicle.toString().slice(-1) == "." ? parseFloat(piece_cicle.toString().slice(0,-1)) : piece_cicle;
    operations1[operation].time_wait_piece_cicle = time_wait_piece_cicle.toString().slice(-1) == "." ? parseFloat(time_wait_piece_cicle.toString().slice(0,-1)) : time_wait_piece_cicle;
    setOperations(operations1);
  }

  const addOperation = () => {
  
    if (codeOp !== "" && alternative !== "" && pph !== "" && piece_cicle !== "" &&
    timeWaitPieceCicle !== "" && selected_MachineOp !== "" && selectedUnit !== "" && pph !== "." && piece_cicle !== "." && timeWaitPieceCicle !== ".") {

      let opAux = operations.filter((element)=> (`${element.code}${element.alternative}`) == (`${codeOp}${alternative}`));
      
      if(opAux.length > 0 && operations.length > 0){
        setMessage("Erro ao adiconar operação! Código e alternativa já adicionados.");
        setShow(true)

      }else{
      objEdit["code"] = codeOp;
      objEditPortuguese["Código"] = codeOp;
      objEdit["alternative"] = alternative;
      objEditPortuguese["Alternativa"] = alternative;
      objEdit["pph"] = pph.toString().slice(-1) == "." ? parseFloat(pph.toString().slice(0,-1)) : pph;
      objEditPortuguese["PPH"] = pph.toString().slice(-1) == "." ? parseFloat(pph.toString().slice(0,-1)) : pph;
      objEdit["piece_cicle"] = piece_cicle.toString().slice(-1) == "." ? parseFloat(piece_cicle.toString().slice(0,-1)) : piece_cicle;
      objEditPortuguese["Nº Peça/Ciclo"] = piece_cicle.toString().slice(-1) == "." ? parseFloat(piece_cicle.toString().slice(0,-1)) : piece_cicle;
      objEdit["time_wait_piece_cicle"] = timeWaitPieceCicle.toString().slice(-1) == "." ? parseFloat(timeWaitPieceCicle.toString().slice(0,-1)) : timeWaitPieceCicle;
      objEditPortuguese["Tempo de espera"] = timeWaitPieceCicle.toString().slice(-1) == "." ? parseFloat(timeWaitPieceCicle.toString().slice(0,-1)) : timeWaitPieceCicle;
      objEdit["machine"] = id_machine;
      objEditPortuguese["Máquina"] = id_machine;
      objEdit["id"] = count;

      setCount(count + 1)
      let obj = objEdit
      let obj2 = objEditPortuguese
      obj["Ação"] = true
      obj2["Ação"] = true

      setOperations([...operations, obj])

      SetOpAllProps([...operationsAllprops, obj2])
      document.getElementById("add-item-form").reset();
      setObjEdit({
        code: "", alternative: "", pph: "", piece_cicle:"",time_wait_piece_cicle:"",machine: 0
      })
      setObjEditPortuguese({
        Código: "", Alternativa: "", PPH: "", ['Nº Peça/Ciclo']: "",['Tempo de espera']:"",Máquina: 0
      })
      SetSelectedMachine("")

      setCodeOp("");
      setAlternative("");
      setPph("");
      setPieceCicle("");
      setTimeWaitPieceCicle("");
      }


    } else {
      if(pph == "." || piece_cicle == "." || timeWaitPieceCicle == "."){
        setMessage("Não foi possível completar essa operação. Um dos campos númericos está preenchido incorretamente.")
      }else{
        setMessage("Necessário preencher todos os campos.")
      }
      setShow(true)
    }
  }

  useEffect(() => {
    if (operations.length > 0 && !render)
      setRender(true)

  }, [operations])


  const handleMachines = (value, label) => {
    let obj = objEdit
    let ob2 = objEditPortuguese
    obj['machine'] = label
    ob2['Máquina'] = label
    const machineOp = machines.find((e) => e.value === value)
    setObjEdit(obj)
    console.log(machineOp);
    SetSelectedMachine(machineOp)
    setIdMachine(machineOp.label)
  }

  const setOperationsCallback = (event) => {
    let auxarr = []
    event.forEach(e => {
      auxarr.push({
        code: e["Código"], alternative: e.Alternativa,
        pph: e.PPH, piece_cicle: e['Nº Peça/Ciclo'],time_wait_piece_cicle:e['Tempo de espera']
        ,machine: e['Máquina']
      })
    })
    SetOpAllProps([...event])
    setOperations([...auxarr])
  }

  const handleUnit = (value) => {
    const unit = units.find((e) => e.value === value)
    setSelectedUnit(unit)
    if(unit !== "" && unit !== null){
      setPopUpShow(true);
    }
    if(unit.value == "pcs" || unit.value == "g"){
      setlength(null);
      setWidth(null);
    }

    if(unit.value == "m"){
      setWidth(null);
    }
  }

  return (
    <div className="item-container box" id="boxItem"style={{flexDirection: "column"}}>
      {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
      {(popUpShow && selectedUnit.value != "pcs" && selectedUnit.value != "g") ? (
        <div className="popUpContainer">
        
        <div className="popUp">
          <h4 className="popUpTitle">Informações sobre a unidade de medida</h4>
          <div className="inputsPopUp">
            {((selectedUnit.value == "m") ? (<div className="element">
            <TextField
                section
                focus={false}
                title="Comprimento"
                name="length"
                id={"length"}
                decimal
                value={length}
                parentCallback={setlength}
              />
            </div>) : null)}

            {((selectedUnit.value == "m2") ? (
              <>
            <div className="element">
            <TextField
                section
                focus={false}
                title="Comprimento"
                name="length"
                id={"length"}
                decimal
                value={length}
                parentCallback={setlength}
              />
            </div>
            <div className="element">
            <TextField
                section
                title="Largura"
                name="width"
                id={"width"}
                decimal
                value={width}
                parentCallback={setWidth}
              />
            </div>
            </>
            ) : null)}
            
          </div>
          
          
            
          <div className="buttonsPopUp">
            <Button title="Salvar" parentCallback={() => {setPopUpShow(false)}}/>
            <Button title="Fechar" id="close" parentCallback={() => {setPopUpShow(false)}}/>
          </div>
        </div>
      </div>
      ) : null}
      
      
      {show ? (
        <Alert
          show={show}
          message={message}
          parentCallback={callbackfunction}
          reload={reload}
        />
      ) : null}

      <div class="minibox">
        <div className="form">
          <h4>Item:</h4>
          <div className="inputs inputsAddItem">
          <div className='tf2AddItem element'>
            <TextField
              section={false}
              focus
              title="Código do Item"
              value={code}
              min={3}
              max={16}
              name="code"
              parentCallback={setCode}
              validationType={"varchar"}
            />
          </div>
          <div className='tf2AddItem element'>
            <TextField
              section={false}
              focus={false}
              title="Descrição do Item"
              value={description}
              min={3}
              max={70}
              name="description"
              parentCallback={setDescription}
            />
          </div>
          <div className='tf2AddItem element'>
              <Select
                label="Unidade de Medidas"
                arrData={units}
                handleSelect={handleUnit}
                selectedID={selectedUnit}
                name={'unit'}
                />
                </div>
              <div className="element badge badgeUnits">
                {
                  (selectedUnit.value != "pcs" && (length != null || width != null)) ? (
                    <>
                    <Badge title={"width"} variant="secondary">L:{width}</Badge>
                    <Badge title={"length"} variant="secondary">C:{length}</Badge>
                    </>
                  ) : (null)
                }
            </div>
          </div>
        </div>
      </div>

      <div className="minibox">
        <form id="add-item-form" className="form">
        <h4>Operações:</h4>
          <div className="inputs inputsAddItem">
            <div className='tf1AddItem element'>
              <TextField
                focus={false}
                title="Código"
                id={"code"}
                name={"code"}
                value={codeOp}
                min={1}
                max={3}
                validationType="varchar"
                parentCallback={setCodeOp}
              />
            </div>
            <div className='tf1AddItem element'>
              <TextField
                section
                focus={false}
                title="Alternativa"
                name={"alternative"}
                id={"alternative"}
                min={1}
                max={6}
                validationType="int"
                value={alternative}
                parentCallback={setAlternative}
              />
            </div>
            <div className='tf1AddItem element'>
              <TextField
                section
                focus={false}
                title="PPH"
                name={"pph"}
                id={"pph"}
                value={pph}
                decimal
                min={1}
                max={6}
                parentCallback={setPph}
              />
            </div>
            <div className='tf1AddItem element'>
              <TextField
                section
                focus={false}
                title="Ciclo peça"
                name={["piece_cicle"]}
                id={["piece_cicle"]}
                value={piece_cicle}
                decimal
                min={1}
                max={6}
                parentCallback={setPieceCicle}
              />
            </div>
            <div className='tf1AddItem element'>
              <TextField
                section
                focus={false}
                title="Tempo de espera"
                name={["time_wait_piece_cicle"]}
                decimal
                min={1}
                max={6}
                value={timeWaitPieceCicle}
                id={'time_wait_piece_cicle'}
                parentCallback={setTimeWaitPieceCicle}
              />
            </div>
            <div className='tf1AddItem element'>
              <Select
                label="Máquina"
                selectedID={selected_MachineOp}
                arrData={machines}
                handleSelect={handleMachines}
                name={'machine'}
              />
            </div>
          </div>
          <div className="buttons" id="buttonsItem">
            <div className='tf1AddItemBtn submitButtonItem'><Button title="+ Adicionar"
            parentCallback={() => addOperation(objEdit)} />
              <Button  size={false} title="Enviar" parentCallback={sendData} />
            </div>
            </div>
        </form>
      </div>
      <div className="minibox">
        {render ? <TableEditable data={operations} del={delOperationNew} alt={altOperation}></TableEditable> : null}
      </div>
    </div>
  );

}

export default AddItems